import slugify from "react-slugify";
import { financeMakes } from "../filters";

export function isBOIMake(make: string): boolean {
	return financeMakes.some(({ label }) => slugify(label) === slugify(make));
}
